import { useEffect, useState } from 'react';
import CustomModal from '../../Modal/CustomModal';
import BorderedButton from '../../Buttons/BorderedButton';
import PrimaryButton from '../../Buttons/PrimaryButton';
import styles from './MembershipTransactionNotePopup.module.css';

const MembershipTransactionNotePopup = ({
    show,
    onClose,
    onConfirm,
    initialNote = '',
    isProcessing = false,
}) => {
    const [note, setNote] = useState(initialNote || '');

    useEffect(() => {
        if (show) {
            setNote(initialNote || '');
        }
    }, [show, initialNote]);

    const handleConfirm = () => {
        if (typeof onConfirm === 'function') {
            onConfirm(note);
        }
    };

    return (
        <CustomModal
            show={show}
            onHide={onClose}
            customClassBody={styles.modalBodyReset}
            customClassModal={styles.modalShell}
            hideCloseButton={true}
        >
            <div className={styles.popup}>
                <button
                    type="button"
                    className={styles.localCloseButton}
                    onClick={onClose}
                    aria-label="Close"
                >
                    &times;
                </button>
                <div className={styles.header}>
                    <h2>Add Notes</h2>
                </div>

                <div className={styles.body}>
                    <textarea
                        id="membership-transaction-note"
                        value={note}
                        onChange={(event) => setNote(event.target.value.trimStart())}
                        className={styles.textarea}
                        rows={4}
                        placeholder="Enter notes..."
                    />
                </div>

                <div className={styles.separator} />

                <div className={styles.footer}>
                    <BorderedButton text="Cancel" onClick={onClose} className={styles.cancelButton} />
                    <PrimaryButton
                        text={isProcessing ? 'Saving...' : 'Confirm'}
                        onClick={handleConfirm}
                        disabled={isProcessing}
                        className={styles.confirmButton}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default MembershipTransactionNotePopup;
